export default [
    {
        name: 'middleAll',
        path: 'middleAll',
        component: () => import('@/pages/BigData/PatentModule/middleCase/middleAll'),
        meta: { title: '全部' },
        props(route) {
            return { id: route.query.id }
        }
    },
    {
        name: 'MiddleToBeDeclared',
        path: 'MiddleToBeDeclared',
        component: () => import('@/pages/BigData/PatentModule/middleCase/MiddleToBeDeclared'),
        meta: { title: '待申报' },
        props(route) {
            return { id: route.query.id }
        }
    },
    {
        name: 'MiddleDeclaring',
        path: 'MiddleDeclaring',
        component: () => import('@/pages/BigData/PatentModule/middleCase/MiddleDeclaring'),
        meta: { title: '申报中' },
        props(route) {
            return { id: route.query.id }
        }
    },
    {
        name: 'MiddleDeclared',
        path: 'MiddleDeclared',
        component: () => import('@/pages/BigData/PatentModule/middleCase/MiddleDeclared'),
        meta: { title: '已申报' },
        props(route) {
            return { id: route.query.id }
        }
    },
    {
        name: 'middleCaseDetials',
        path: 'middleCaseDetials',
        redirect:{name:'mShenBaoCaiLiao'},
        component: () => import('@/pages/BigData/PatentModule/middleCaseDetials'),
        meta: { title: '详情' },
        props(route) {
            return { id: route.query.id }
        },
        children: [
            {
                name: 'mShenBaoCaiLiao',
                path: 'mShenBaoCaiLiao',
                component: () => import('@/pages/BigData/PatentModule/middleCaseDetials/mShenBaoCaiLiao'),
                meta: { title: '申报材料' },
                props(route) {
                    return { id: route.query.id }
                }, 
            },
            {
                name: 'mCPCAnJuanBao',
                path: 'mCPCAnJuanBao',
                component: () => import('@/pages/BigData/PatentModule/middleCaseDetials/mCPCAnJuanBao'),
                meta: { title: 'CPC案卷包' },
                props(route) {
                    return { id: route.query.id }
                }, 
            },
            {
                name: 'mTongZhiWenShu',
                path: 'mTongZhiWenShu',
                component: () => import('@/pages/BigData/PatentModule/middleCaseDetials/mTongZhiWenShu'),
                meta: { title: '通知文书' },
                props(route) {
                    return { id: route.query.id }
                }, 
            },
        ]
    },
]